import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const PhoneIcon = ({
  color = '$primary-main',
  width = '12',
  height = '12',
  className
}: IconProps) => {
  const svgWidth = `${width}px`;
  const svgHeight = `${height}px`;
  const numericWidth = parseInt(width, 10);
  const numericHeight = parseInt(height, 10);
  return <SvgIcon className={className} style={{
    width: svgWidth,
    height: svgHeight
  }} viewBox={`0 0 ${numericWidth} ${numericHeight}`} xmlns="http://www.w3.org/2000/svg" data-sentry-element="SvgIcon" data-sentry-component="PhoneIcon" data-sentry-source-file="PhoneIcon.tsx">
			<path d="M11.3487 8.32533C10.9287 8.31533 10.4 8.29067 10.066 8.232C9.70467 8.168 9.27 8.044 8.964 7.94867C8.724 7.874 8.46267 7.94 8.28467 8.11733L6.80667 9.58667C5.78533 9.04867 4.96733 8.422 4.27467 7.72533C3.578 7.03267 2.95133 6.21467 2.41333 5.19333L3.88267 3.71467C4.06 3.53667 4.126 3.27533 4.05133 3.03533C3.95667 2.73 3.832 2.29533 3.76867 1.934C3.70933 1.6 3.68533 1.07133 3.67467 0.651333C3.666 0.288 3.37 0 3.00667 0H0.666667C0.374667 0 0 0.218667 0 0.666667C0 3.69267 1.22667 6.58267 3.31067 8.68933C5.41733 10.7733 8.30733 12 11.3333 12C11.7813 12 12 11.6253 12 11.3333V8.99333C12 8.63 11.712 8.334 11.3487 8.32533Z" fill={color} data-sentry-element="path" data-sentry-source-file="PhoneIcon.tsx" />
		</SvgIcon>;
};
export default PhoneIcon;